<template>
    <x-dialog class="x-tree-selection-dialog" :visible="visible" :config="getTreeConfig(config)"
        @close="$emit('close')"
        @confirm="confirmHandler"
        @update:visible="(visible)=> $emit('update:visible', visible)"
    >
        <template v-if="config.favourite" #header="{ close, title, titleId, titleClass }">
            <el-tabs v-model="activeTab" @tab-change="tabChangeHandler">
                <el-tab-pane :label="title" name="default"></el-tab-pane>
                <el-tab-pane label="收藏夹" name="favourite"></el-tab-pane>
            </el-tabs>
        </template>
        <x-tree-view
            :config="getSelectionConfig(config, activeTab)"
            :select-type="selectType"
            v-model:selected="modelValue"
            :data="data"
            @update:selected="selectedHandler"
        ></x-tree-view>
    </x-dialog>
</template>
<script setup>
import { getCurrentInstance, reactive, ref, watch } from 'vue';
import SelectType from '../components/data/SelectType';
import XTreeView from '../viewmodule/XTreeView.vue';
import XDialog from './XDialog.vue';
import ModuleCenter from '../datamodule/ModuleCenter';
import { useTokenStore } from '../store/TokenStore';

const inst = getCurrentInstance();

const token = useTokenStore()

const activeTab = ref('default');

const props = defineProps({
    visible: { default: true },
    config: { default: null },
    selectType: { default: SelectType.MULTIPLE_SELECT },
    selected: { default: null },
    dataOptions: { default: null },

    data: { default: null },
})

defineEmits({
    'close': null,
    'update:visible': null,
    'update:modelValue': null,
    'confirm': null,
})

const findOption = (options, key)=> {
    for (const option of options) {
        if (option.value == key) return option;
    }
    return null;
}
const mergeOpions = (selected)=> {
    if (!selected) return;
    if (!(selected instanceof Array)) selected = [selected];
    const options = props.dataOptions ? [...props.dataOptions] : [];
    if (!selected) return options;
    const keyField = props.config?.keyField || 'id';
    const nameField = props.config?.nameField || 'name';
    for (const data of selected) {
        if (!findOption(options, data[keyField])) {
            options.push({value:data[keyField], label:data[nameField]});
        }
    }
    return options;
}
const updateOptions = (selected)=> {
    // defaultOptions.value = mergeOpions(selected);
}

const defaultOptions = ref(null);
watch(()=> props.dataOptions, (value)=> {
    defaultOptions.value = value;
}, {immediate:true})
const modelValue = ref(null);
watch(()=> props.selected, (value)=> {
    const module = ModuleCenter.getModule(props.config.module);
    if (module) {
        const keyField = props.config?.keyField || 'id';
        const data = props.selectType != SelectType.SINGLE_SELECT ? module.getDatasLocal(value, keyField) : module.getDataLocal(value, keyField);
        updateOptions(data);
        modelValue.value = data;
    }
    
}, {immediate:true})

const selectedHandler = (selected)=> {
    updateOptions(selected);
}

const confirmHandler = (value, action)=> {
    const module = ModuleCenter.getModule(props.config.module);
    if (module) {
        const value = props.selectType != SelectType.SINGLE_SELECT ? module.datasKeys(modelValue.value, props.config?.keyField || 'id') : module.dataKey(modelValue.value, props.config?.keyField || 'id');
        inst.emit('confirm', {selected:value, module:props.config.module, data:modelValue.value, options:defaultOptions.value}, action);
    } else {
        inst.emit('confirm', {selected:null, module:props.config.module, data:modelValue.value, options:defaultOptions.value}, action);
    }
}
const tabChangeHandler = (tab)=> {
    console.log(tab);
    console.log(props.config);
}
const getSelectionConfig = (config, tab)=> {
    if (!tab || tab == 'default') return config;
    else {
        const conf = Object.assign({}, config);
        let condition = conf.condition || '';
        const fModule = ModuleCenter.getModule(config.favourite)
        const {idField, typeField} = fModule._bindEntity;
        const relation = fModule.getModuleRelation(config.module);
        const userId = token.userid;
        const extCondition = `${relation.destField},${idField}:${config.favourite}.userId?'${userId}'&&${relation.destField},${idField}:${config.favourite}.${typeField}?'${config.module}'`
        condition += condition ? ('&&' + extCondition) : extCondition;
        conf.condition = condition;
        console.log(conf.condition);
        return conf;
    }
}
const getTreeConfig = (config)=> {
    config.width = 600;
    return config;
}
</script>